import { render, staticRenderFns } from "./online-contracts.vue?vue&type=template&id=67045403&scoped=true&"
import script from "./online-contracts.vue?vue&type=script&lang=js&"
export * from "./online-contracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67045403",
  null
  
)

export default component.exports